type RelativeTime = {
  unit: string;
  value: number;
};

const UNITS: Record<string, number> = {
  day: 24 * 60 * 60 * 1_000,
  hour: 60 * 60 * 1_000,
  minute: 60 * 1_000,
};

const useRelativeTime = (date: Date): RelativeTime | undefined => {
  const now = new Date();
  const elapsed = Number(date) - Number(now);

  for (const unit in UNITS) {
    if (Math.abs(elapsed) > UNITS[unit] || unit === "minute") {
      return {
        unit,
        value: Math.round(elapsed / UNITS[unit]),
      };
    }
  }
};

export type { RelativeTime };
export { useRelativeTime };
